<template>
  <div
    id="app"
    class="wrapper"
  >
    <the-header />
    <the-sidebar />
    <main class="content-wrapper">
      <section class="content">
        <cabinet-old
          v-if="module === 'seo' || $route.name === 'Home'"
          to="client2.demis.ru"
        />
        <cabinet-old
          v-if="module === 'context'"
          to="context.demis.ru"
        />
        <the-breadcrumbs />
        <router-view v-if="!module || (!servicesFetching && isModuleAllowed)" />
        <div
          v-if="module && !servicesFetching && !isModuleAllowed"
          class="alert alert-warning"
        >
          Данная услуга не подключена. Для заказа обратитесь к своему аккаунт менеджеру.
        </div>
        <c-loading-overlay v-if="module && servicesFetching" />
      </section>
    </main>
    <the-footer />
    <the-modals />
  </div>
</template>

<script>
import TheHeader from './components/layout/TheHeader'
import TheSidebar from './components/layout/TheSidebar'
import TheFooter from './components/layout/TheFooter'
import TheModals from './components/layout/TheModals'
import TheBreadcrumbs from './components/layout/TheBreadcrumbs'
import CabinetOld from './components/CabinetOld'
import CLoadingOverlay from './components/ui/CLoadingOverlay'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    TheBreadcrumbs,
    TheHeader,
    TheSidebar,
    TheModals,
    TheFooter,
    CabinetOld,
    CLoadingOverlay
  },
  computed: {
    isModuleAllowed () {
      return this.isServiceConnected(this.module)
    },
    ...mapState({
      module: state => state.module,
      servicesFetching: state => state.services.fetching
    }),
    ...mapGetters({
      isServiceConnected: 'services/isConnected'
    })
  }
}
</script>
